// extracted by mini-css-extract-plugin
export default {"wrapper":"kGRSf","open-animation":"Ek62M"};